/*
  Caviére product page buy box (Feature 2)
  1. Keeps the price in the summary in step with the size the shopper picks.
  2. Scrolls smoothly to the reviews when the star rating is tapped.
  Plain JavaScript, no libraries. About 2 KB.
*/
(function () {
  if (window.__caviereProductPage) return;
  window.__caviereProductPage = true;

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function setPrice(cents) {
    if (typeof cents !== 'number') return;
    document.querySelectorAll('[data-cav-price]').forEach(function (el) {
      el.textContent = formatMoney(cents);
    });
  }

  // Dawn announces every size change on its own event channel.
  function listenForVariantChanges() {
    // PUB_SUB_EVENTS is declared with const in Dawn's constants.js, so it is not on window.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant) setPrice(variant.price);
      });
    }
    // Backup: read Dawn's selected-variant data after any option change.
    document.addEventListener('change', function (event) {
      if (!event.target.closest('variant-selects, variant-radios, .product-form__input')) return;
      setTimeout(function () {
        var data = document.querySelector('variant-selects [data-selected-variant]');
        if (!data) return;
        try {
          var variant = JSON.parse(data.textContent);
          if (variant) setPrice(variant.price);
        } catch (e) {}
      }, 250);
    });
  }

  function findReviews() {
    return document.querySelector(
      '.jdgm-rev-widg, .jdgm-widget.jdgm-review-widget, [id*="judge_me_reviews_review_widget"]'
    );
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cav-reviews-link]');
    if (!link) return;
    var target = findReviews();
    if (!target) return;
    event.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', listenForVariantChanges);
  } else {
    listenForVariantChanges();
  }
})();